import { NotificationManager } from "react-notifications";

import { NOTIFICATION_DEFAULT_DURATION } from "constants/globalConstants";

import "react-notifications/lib/notifications.css";
import "../../../src/styles/global/_notification.scss";
export const SUCCESS_NOTIFICATION = "SUCCESS";
export const WARNING_NOTIFICATION = "WARNING";
export const ERROR_NOTIFICATION = "ERROR";
export const INFO_NOTIFICATION = "INFO";

const createNotification = (type, message, title, inputDuration = NOTIFICATION_DEFAULT_DURATION) => {
  //Function to calculate the time required to read the given text - Based on the research that the user reads 2-3 words per second
  const calculateDuration = descriptionText => {
    const arr = descriptionText.split(" ");
    const textLength = arr.filter(word => word !== "").length;
    const calculatedDuration = (textLength / 2) * 1000;
    return calculatedDuration > inputDuration ? calculatedDuration : inputDuration;
  };

  const duration = calculateDuration(message);
  const onClick = () => false;

  switch (type) {
    case INFO_NOTIFICATION:
      return NotificationManager.info(message, title, duration, onClick, false);
    case SUCCESS_NOTIFICATION:
      return NotificationManager.success(message, title, duration, onClick, false);
    case WARNING_NOTIFICATION:
      return NotificationManager.warning(message, title, duration, onClick, false);
    case ERROR_NOTIFICATION:
      return NotificationManager.error(message, title, duration, onClick, true);
    default:
      return NotificationManager.info(message, title, duration, onclick, false);
  }
};

export default createNotification;
